import { render } from "./TotalCheck.vue?vue&type=template&id=e80df7f0&scoped=true&ts=true"
import script from "./TotalCheck.vue?vue&type=script&lang=ts"
export * from "./TotalCheck.vue?vue&type=script&lang=ts"

import "./TotalCheck.vue?vue&type=style&index=0&id=e80df7f0&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80df7f0"]])

export default __exports__